// ============================================================
// admin-security.nav.ts — Phase-4 migration descriptor
// ------------------------------------------------------------
// Component-free, data-only navigation descriptor for the Admin
// Security group (Organizations / Users). Imports ONLY pure
// types/constants (@twist/ui-navigation types + @twist/core security
// primitives) — no component / feature code — so the registry stays a
// pure data graph.
//
// Mirrors the legacy sideNavConfig "Admin › Security" group. The legacy
// group + sub-items were gated TwistAdmin-only, but the LIVE CIAM routes
// (/admin/ciam/organizations, /admin/ciam/users) carry STRICTER guards:
//   - organizations → TwistAdmin + ADMIN__OrganizationManagementRead
//   - users         → TwistAdmin + ADMIN__UserManagementRead
// We copy the stricter ROUTE guards verbatim so nav-visible ⊆
// route-accessible (no nav entry the user can't actually open).
//
// Whole-group migration: the children carry the `sidebar` surface so the
// legacy "Security" Admin group de-dups out (every sub-item path is
// piloted). The registry projects this descriptor as a SINGLE top-level
// "Security" leaf (→ /admin/ciam/organizations); the children power
// de-dup + the command palette + breadcrumb resolution.
// ============================================================
import { OrgPermissions, TWIST_ADMIN_ONLY } from '@twist/core';
import type { NavDescriptor } from '@twist/ui-navigation';

const ORGANIZATIONS_SECURITY = {
  ...TWIST_ADMIN_ONLY,
  orgPermissions: [OrgPermissions.ADMIN__OrganizationManagementRead],
};

const USERS_SECURITY = {
  ...TWIST_ADMIN_ONLY,
  orgPermissions: [OrgPermissions.ADMIN__UserManagementRead],
};

export const adminSecurityNav: NavDescriptor = {
  id: 'admin-security',
  path: '/admin/ciam/organizations',
  label: 'Security',
  icon: 'gearsDatabase',
  group: 'Admin',
  // Admin section = 40s; Security third (after Manufacturing hub,
  // Definitions).
  order: 42,
  surfaces: ['sidebar', 'palette'],
  security: ORGANIZATIONS_SECURITY,
  children: [
    {
      id: 'admin-organizations',
      path: '/admin/ciam/organizations',
      label: 'Organizations',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: ORGANIZATIONS_SECURITY,
    },
    {
      id: 'admin-users',
      path: '/admin/ciam/users',
      label: 'Users',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: USERS_SECURITY,
    },
  ],
};
